module.exports = __webpack_public_path__ + "img/fanyi.6aafe6d1.svg";